import { CustomHeader } from "@/components/CustomHeader";
import { PhoneVerifyBanner } from "@/components/PhoneVerifyBanner";
import { PostCard } from "@/components/PostCard";
import { ThemedText } from "@/components/ThemedText";
import { ThemedView } from "@/components/ThemedView";
import VehiLinkIcon from "@/components/ui/VehiLinkIcon";

import { usePosts } from "@/context/PostsContext";
import { useThemeColor } from "@/hooks/useThemeColor";

import { ActionSheetProvider } from "@expo/react-native-action-sheet";
import Ionicons from "@expo/vector-icons/Ionicons";
import { router } from "expo-router";
import { StatusBar } from "expo-status-bar";
import { useTranslation } from "react-i18next";

import {
  ActivityIndicator,
  FlatList,
  RefreshControl,
  StyleSheet,
  TouchableOpacity,
} from "react-native";

function HomeScreenInner() {
  const {
    posts,
    initialLoading,
    loadingMore,
    refreshing,
    fetchMorePosts,
    onRefresh,
  } = usePosts();
  const tintColor = useThemeColor({}, "tint");
  const { t } = useTranslation();

  return (
    <>
      <CustomHeader
        childrenStyle={{ justifyContent: "center", alignItems: "center" }}
      >
        <VehiLinkIcon size={48} />
      </CustomHeader>
      <StatusBar style="dark" animated={true} />
      <PhoneVerifyBanner />
      {initialLoading ? (
        <ThemedView style={styles.overlay}>
          <ActivityIndicator size="large" color={tintColor} />
        </ThemedView>
      ) : posts.length > 0 ? (
        <FlatList
          data={posts}
          renderItem={({ item }) => <PostCard post={item} />}
          keyExtractor={(item) => item.id}
          style={styles.flatListStyle}
          onEndReached={fetchMorePosts}
          onEndReachedThreshold={0.5}
          ListFooterComponent={
            loadingMore ? (
              <ActivityIndicator size="large" color={tintColor} />
            ) : null
          }
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
          }
        />
      ) : (
        <ThemedText
          style={{
            textAlign: "center",
            marginTop: 20,
          }}
        >
          <ThemedText>{t("NO_POSTS_FOUND")}</ThemedText>
        </ThemedText>
      )}
      <TouchableOpacity
        style={styles.fab}
        onPress={() =>
          router.push({
            pathname: "/(tabs)/post/new",
            params: { targetName: t("GLOBAL_FEED") },
          })
        }
      >
        <Ionicons name="add" size={30} color="white" />
      </TouchableOpacity>
    </>
  );
}

export default function HomeScreen() {
  return (
    <ActionSheetProvider>
      <HomeScreenInner />
    </ActionSheetProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  overlay: {
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1,
    flex: 1,
  },
  flatListStyle: {
    flex: 1,
  },
  fab: {
    position: "absolute",
    width: 56,
    height: 56,
    alignItems: "center",
    justifyContent: "center",
    right: 20,
    bottom: 10,
    backgroundColor: "#1e3a8a",
    borderRadius: 30,
    elevation: 8,
    zIndex: 10,
  },
});
